import React from "react";
import DateCard from "./DateCard";
import { CousrsDetailsType } from "@/app/types";
import { useTranslations } from "next-intl";

function PrivateDateCard({ course }: DatesCardsPropsType) {
  const t = useTranslations("courses.dates.private");

  return (
    <DateCard
      color="#F2E30C"
      dates={course?.dateSlots?.filter((date) => date.type == "Private")}
      name={t("title")}
      numberOfStudents={t("info")}
      studentsInClass={t("subInfo")}
      price={course?.privateMonthlyPrice}
      textColor="#220859"
    />
  );
}

export default PrivateDateCard;
type DatesCardsPropsType = {
  course: CousrsDetailsType;
};
